"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fallbackTranslations = {
    'changelogTitle': 'Latest Updates',
    'changelogEmptyText': 'No releases yet',
    'allUpdatesLinkText': 'Read all updates',
    'taggedPostsTitle': 'Tagged Posts'
};
exports.fallbackBrandColors = {
    'primary-light': '#e9d8fd',
    'primary': '#6b46c1',
    'primary-dark': '#44337a'
};
